'use strict';

$('body').on('click', '.rpp-view-link, .first-rpp-enroll-link, .second-rpp-enroll-link', function (e) {
    if ($('#isAuthenticated').val() !== 'true') {
        e.preventDefault();
        var redirecturl = $(this).attr('data-url');
        if (redirecturl) {
            localStorage.setItem('rpplandingpage', redirecturl);
        }
        $('#ckc-login-modal').modal('show');
    }
});

$('.live-case-example-section').on('click', '.view-the-cases', function (e) {
    var $target = $('.rp-landing-page-container').first();

    if ($target.length) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: Math.max($target.offset().top - 150, 0)
        }, 500);
    }
});
